"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DurationDialog = void 0;
var React = __importStar(require("react"));
var react_1 = require("react");
var core_1 = require("@material-ui/core");
var durationFieldsContainer_1 = require("./durationFieldsContainer");
var defaultLabelsEn_json_1 = __importDefault(require("./defaultLabelsEn.json"));
var utils_1 = require("./utils");
var DurationDialog = function (_a) {
    var _time = _a.time, onDismiss = _a.onDismiss, onAccept = _a.onAccept, views = _a.views, _labels = _a.labels, formatDuration = _a.formatDuration, DurationFieldsContainerProps = _a.DurationFieldsContainerProps, _b = _a.DurationFieldsContainerComp, DurationFieldsContainerComp = _b === void 0 ? durationFieldsContainer_1.DurationFieldsContainer : _b, props = __rest(_a, ["time", "onDismiss", "onAccept", "views", "labels", "formatDuration", "DurationFieldsContainerProps", "DurationFieldsContainerComp"]);
    var theme = (0, core_1.useTheme)();
    var _c = (0, react_1.useState)(_time), time = _c[0], setTime = _c[1];
    (0, react_1.useEffect)(function () {
        setTime(_time);
    }, [_time]);
    var duration = (0, utils_1.timeToDuration)(time);
    var labels = __assign(__assign({}, defaultLabelsEn_json_1.default), _labels);
    return (React.createElement(core_1.Dialog, __assign({ fullWidth: true, onClose: function () { return onDismiss(); } }, props),
        React.createElement(core_1.Toolbar, { style: {
                backgroundColor: (DurationFieldsContainerProps === null || DurationFieldsContainerProps === void 0 ? void 0 : DurationFieldsContainerProps.dialogBackgroundColor) ||
                    theme.palette.primary.main,
                color: (DurationFieldsContainerProps === null || DurationFieldsContainerProps === void 0 ? void 0 : DurationFieldsContainerProps.dialogColor) ||
                    theme.palette.primary.contrastText,
            } },
            React.createElement(core_1.Typography, { variant: 'h4' }, duration && formatDuration(duration))),
        React.createElement(core_1.DialogContent, null,
            React.createElement(DurationFieldsContainerComp, __assign({ views: views, value: time, setValue: setTime }, DurationFieldsContainerProps))),
        React.createElement(core_1.DialogActions, null,
            React.createElement(core_1.Button, { onClick: function () {
                    onDismiss();
                }, color: 'primary' }, labels.cancel),
            React.createElement(core_1.Button, { onClick: function () {
                    onAccept(time);
                    onDismiss();
                }, color: 'primary' }, labels.ok))));
};
exports.DurationDialog = DurationDialog;
